import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';

export default function Video(props){
  const[video_src, setVideoSrc]=useState('');
  useEffect(()=>{
    axios.get('/api/video_url/'+props.video).then((response)=>{setVideoSrc(response.data);});
  },[props.video]);
  let src=video_src; if(src.includes('?')==true){src+='&rel=0&showinfo=0'}else{src+='?rel=0&showinfo=0';} if(props.autoplay==true){src+='&autoplay=1';}
  console.log('VIDEO', src);
  return(
    <iframe style={props.style} src={src} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen autoplay={props.autoplay}></iframe>
  )
  
}
